import AttachFileIcon from "@mui/icons-material/AttachFile";
import ChatBubbleOutlinedIcon from '@mui/icons-material/ChatBubbleOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import {
  CircularProgress,
  IconButton,
  TextField
} from "@mui/material";
import { useContext, useState } from "react";
import { toast } from 'react-toastify';
import {
  CaptionTypography,
  ChatConnectionStateContainer,
  ChatMessage,
  ChatPaper,
  CloseChatButton,
  FechaHoraEnvio,
  FileLink,
  Header,
  HeaderTitleContainer,
  IconWrapper,
  MessageBox,
  MessagesContainer,
  SendButton,
  SendMessageContainer,
  TitleBox,
  TitleTypography
} from "../../../../styled/Chat";
import { RoomContext } from "../context/roomContext";


const ChatComponent = ({
  zoomChat,
  participants,
  messages,
  toggleChat,
  uploadProgress,
}) => {
  const zmClient = useContext(RoomContext);
  const [newMessage, setNewMessage] = useState(null);
  const [downloadedFiles, setDownloadedFiles] = useState({});
  const handleSendMessage = async () => {
    if (!zoomChat) return;
    try {
      const currentUser = zmClient.getCurrentUserInfo()?.userId;
      const recipient = participants.find(
        (user) => user.userId !== currentUser,
      );
      if (!recipient) {
        toast.error("Espere a que se una el otro participante para enviar mensajes.");
        return;
      }
      if (newMessage && newMessage.trim()) {
        await zoomChat.send(newMessage ?? " ", recipient.userId);
        setNewMessage("");
      }
    } catch (error) {
      toast.error("Error al enviar el mensaje:" + error);
    }
  };

  const sendFiles = async (files) => {
    try {
      const currentUser = zmClient.getCurrentUserInfo()?.userId;
      const recipient = participants.find(
        (user) => user.userId !== currentUser,
      );
      if (!recipient) {
        toast.error("Espere a que se una el otro participante para enviar mensajes.");
        return;
      }
      // Enviar archivos (si hay alguno)
      if (files.length > 0) {
        for (let file of files) {
          try {
            await zoomChat.sendFile(file, recipient.userId);
          } catch (error) {
            const { reason } = error;
            let fileErrorMessage;
            switch (reason) {
              case "File is not in the allow list":
                fileErrorMessage = `El archivo ${file.name} no tiene un tipo permitido.`;
                break;
              case "File size exceeds the maximum limit.":
                fileErrorMessage = `El archivo ${file.name} excede el tamaño máximo permitido.`;
                break;
              default:
                fileErrorMessage = `El archivo ${file.name} no se pudo enviar, por favor intente nuevamente`;
            }
            toast.error(fileErrorMessage);
          }
        }
      }
    } catch (error) {
      toast.error("Error al enviar el mensaje:" + error);
    }
  }
  const handleDownloadFile = (fileUrl, msgId) => {
    zoomChat.downloadFile(msgId, fileUrl);
    setDownloadedFiles((prev) => ({ ...prev, [msgId]: true }));
  }

  return (
    <ChatPaper elevation={3}>
      <Header>
        <HeaderTitleContainer>
          <IconWrapper>
            <ChatBubbleOutlinedIcon fontSize="small" />
          </IconWrapper>
          <TitleBox>
            <TitleTypography variant="h6">Chat</TitleTypography>
            <ChatConnectionStateContainer>
              <CircleIcon sx={{ color: participants.length > 1 ? 'green' : 'grey', fontSize: 12 }} />
              <CaptionTypography variant="caption">
                {participants.length > 1
                  ? "En linea"
                  : "Esperando otro participante"
                }
              </CaptionTypography>
            </ChatConnectionStateContainer>
          </TitleBox>
        </HeaderTitleContainer>
        <CloseChatButton
          size="small"
          onClick={toggleChat}
        >
          <CloseIcon fontSize="small" />
        </CloseChatButton>
      </Header>

      <MessagesContainer>
        {messages.map((msg) => (
          <MessageBox key={msg.id}>
            <strong>{msg.senderName}:</strong>
            <ChatMessage sx={{ margin: 0, paddingRight: '30px' }}>{msg.mensaje}</ChatMessage>
            <FechaHoraEnvio>
              {new Date(msg.fechaHoraEnvio).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </FechaHoraEnvio>
            {msg.archivo && (
              <>
                <p style={{ margin: "4px 0" }}>
                  📎{" "}
                  <FileLink
                    onClick={() => handleDownloadFile(msg.archivo.fileUrl, msg.zoomId)}
                    style={{
                      color: downloadedFiles[msg.zoomId] ? "green" : "blue",
                    }}>
                    {msg.archivo.nombreArchivo}
                  </FileLink>
                </p>
              </>
            )}
          </MessageBox>
        ))}
      </MessagesContainer>
      <SendMessageContainer>
        <TextField
          fullWidth
          inputProps={{maxLength: 1000}}
          helperText={`${newMessage?.length ?? 0}/1000`}
          variant="outlined"  
          value={newMessage ?? ""}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Escribe un mensaje..."
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
        />
        <label htmlFor="file-upload">
          <IconButton component="span" disabled={uploadProgress}>
            <input
              type="file"
              style={{ display: "none" }}
              id="file-upload"
              onChange={(e) => sendFiles(Array.from(e.target.files))}
              multiple
            />
            <div style={{ position: "relative" }}>
              {uploadProgress ? <CircularProgress size={12} /> : <AttachFileIcon />}
            </div>
          </IconButton>
        </label>
        <SendButton variant="contained" onClick={handleSendMessage}>
          <SendIcon />
        </SendButton>
      </SendMessageContainer>
    </ChatPaper>
  );
};

export default ChatComponent;
